export default __webpack_public_path__ + "static/media/windflower.b4d48d6b.svg";